import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import api from "../lib/api";
import { Reveal, Eyebrow } from "../components/Reveal";
import { useTitle } from "../hooks/useTitle";

export default function Blog() {
  useTitle("Knowledge Centre");
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    api.get("/blog").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="blog-page">
      <section className="bg-[#0A192F] relative overflow-hidden py-16 lg:py-24">
        <div className="absolute inset-0 hero-grid" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Eyebrow light>Knowledge Centre</Eyebrow>
          <h1 className="font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-2xl leading-[1.1]">
            Tally, GST & career insights — from practitioners.
          </h1>
        </div>
      </section>
      <section className="py-16 lg:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {posts.length === 0 ? (
          <p className="text-sm text-[#627D98]" data-testid="blog-empty">Articles coming soon.</p>
        ) : (
          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {posts.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.06}>
                <Link
                  to={`/blog/${p.slug}`}
                  data-testid={`blog-card-${p.slug}`}
                  className="group block h-full bg-white rounded-2xl border border-slate-200 p-7 hover:border-[#0F5132]/50 hover:shadow-[0_16px_40px_rgba(10,25,47,0.1)] hover:-translate-y-1 transition-all duration-300"
                >
                  <span className="px-2.5 py-1 rounded-full bg-[#E8F5E9] text-[#0F5132] text-[10px] font-mono-sn font-bold tracking-wider">
                    {p.category}
                  </span>
                  <h2 className="font-display font-bold text-lg text-[#0A192F] leading-snug mt-4">{p.title}</h2>
                  <p className="text-sm text-[#486581] leading-relaxed mt-3">{p.excerpt}</p>
                  <span className="mt-5 inline-flex items-center gap-1.5 text-sm font-bold text-[#0F5132] group-hover:gap-3 transition-all">
                    Read article <ArrowRight size={15} />
                  </span>
                </Link>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
